import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download/69d13d2d34b9ae00146a2a1f/aqarmarket/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d13d2d34b9ae00146a2a1f/aqarmarket/src/components/AIChatbot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d13d2d34b9ae00146a2a1f/aqarmarket/src/components/TermsModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download/69d13d2d34b9ae00146a2a1f/aqarmarket/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleProvider"] */ "/home/ubuntu/download/69d13d2d34b9ae00146a2a1f/aqarmarket/src/contexts/LocaleContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69d13d2d34b9ae00146a2a1f/aqarmarket/src/styles/tailwind.css");
